import { createFileRoute, Navigate } from '@tanstack/react-router';

import { OffHoursSection } from '@apps/web/components/settings/off_hours_section';
import {
    SettingsPageShell,
    useSettingsGates,
} from '@apps/web/features/settings';

export const Route = createFileRoute('/_app/settings/off-hours')({
    component: OffHoursPage,
});

function OffHoursPage() {
    const { organizationId, gates } = useSettingsGates();
    if (!gates.canManageOrgSettings) {
        return <Navigate to="/settings" replace={true} />;
    }
    if (organizationId === null) {
        return null;
    }

    return (
        <SettingsPageShell
            title="Shift confirmation off hours"
            description="Control how shift confirmation replies are handled outside working hours."
        >
            <OffHoursSection organizationId={organizationId} />
        </SettingsPageShell>
    );
}
